import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'
import patient from '../../stores/patient'
import Header from './Header'
import NameDate from './NameDate'
import Notes from './Notes'
import Plans from './Plans'

const NothingToPrint = styled.div`
  font-size: 2rem;
  font-weight: 300;
  text-align: center;
  padding: 4rem 2rem;
`

@observer
export default class PrintPlan extends Component {
  render() {
    const nothingToPrint = (
      !patient.fields.patientNotes &&
      !patient.fields.planNotes &&
      !patient.hasPlans
    )

    return (
      <Fragment>
        {nothingToPrint &&
          <NothingToPrint>
            <Text str="prose.nothingToPrint" />
          </NothingToPrint>
        }
        {(patient.fields.patientNotes || patient.fields.planNotes) &&
          <Fragment>
            <NameDate />
            {patient.fields.patientNotes &&
              <Fragment>
                <Header str="titles.notesForYourDoctor" />
                <Notes>{patient.fields.patientNotes}</Notes>
              </Fragment>
            }
            {patient.fields.planNotes &&
              <Fragment>
                <Header str="titles.planNotes" />
                <Notes>{patient.fields.planNotes}</Notes>
              </Fragment>
            }
          </Fragment>
        }
        {patient.hasPlans &&
          <Fragment>
            <NameDate breakBefore />
            <Plans />
          </Fragment>
        }
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/PrintPlan.js